import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import ImportBranchModal from "./partials/ImportBranchModal";

import {
    getBranches as onGetBranches,
    addNewBranch as onAddNewBranch,
    updateBranch as onUpdateBranch,
    deleteBranch as onDeleteBranch,

    //getDepartments as onGetDepartments,
    getTrainingTypes as onGetTrainingTypes,


} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Branch = () => {

    //meta title
    document.title = "Filières | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [branch, setBranch] = useState(null);

    const [modalOpen, setModalOpen] = useState(false);
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            uid: (branch && branch.uid) || '',
            name: (branch && branch.name) || '',
            code: (branch && branch.code) || '',
            //department_id: (branch && branch.department_id) || '',
            training_type_id: (branch && branch.training_type_id) || '',
            //description: (eventCategory && eventCategory.description) || '',
            
        },
        validationSchema: Yup.object({
           
            name: Yup.string().required("Veuillez saisir le name"),
            code: Yup.string().required("Veuillez saisir le code"),
            //department_id: Yup.string().required("Veuillez sélectionner le département"),
            training_type_id: Yup.string().required("Veuillez sélectionner le type de formation"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const updateBranch = {
                    //id: values.id,
                    uid: values.uid,
                    name: values.name,
                    code: values.code,
                    //department_id: values.department_id,
                    training_type_id: values.training_type_id,
                    //description: values.description,
                    
                };
                // update movie category
                dispatch(onUpdateBranch(updateBranch));
                validation.resetForm();
            } else {
                const newBranch = {
                    //id: values["id"],
                    //uid: values["uid"],
                    name: values["name"],
                    code: values["code"],
                    //department_id: values["department_id"],
                    training_type_id: values["training_type_id"],
                    //description: values["description"],
                   
                };
                // save new movie category
                dispatch(onAddNewBranch(newBranch));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const BranchProperties = createSelector(
        (state) => state.branchReducer, // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
        (branchReducer) => ({
            branches: branchReducer.branches,
            loading: branchReducer.loading
        })
    );

    const {branches, loading} = useSelector(BranchProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {
        if (branches && !branches.length) {
            dispatch(onGetBranches());
        }
    }, [dispatch, branches]);


    // Departments

    /*
    const DepartmentProperties = createSelector(
        (state) => state.departmentReducer, 
        (departmentReducer) => ({
            departments: departmentReducer.departments,
            loading: departmentReducer.loading
        })
    );

    const {departments} = useSelector(DepartmentProperties);


    

    useEffect(() => {
        if (departments && !departments.length) {
            dispatch(onGetDepartments());
        }
    }, [dispatch, departments]);

    */
    


    // TRAINING TYPES
    const TrainingTypeProperties = createSelector(
        (state) => state.trainingTypeReducer, 
        (trainingTypeReducer) => ({
            trainingTypes: trainingTypeReducer.trainingTypes,
            loading: trainingTypeReducer.loading
        })
    );

    const {trainingTypes} = useSelector(TrainingTypeProperties);


    

    useEffect(() => {
        if (trainingTypes && !trainingTypes.length) {
            dispatch(onGetTrainingTypes());
        }
    }, [dispatch, trainingTypes]);

    const toggle = () => {
        if (modal) {
            setModal(false);
            setBranch(null);
        } else {
            setModal(true);
        }
    };

    const handleBranchClick = arg => {
        const branch = arg;
        setBranch({
            //id: serialeventCategory.id,
            uid: branch.uid,
            name: branch.name,
            code: branch.code,
            department_id: branch.department_id,
            program_type_id: branch.program_type_id,
            //description: eventCategory.description,
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (branch) => {
        setBranch(branch);
        setDeleteModal(true);
    };

    const handleDeleteBranch = () => {
        if (branch && branch.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeleteBranch(branch));
            setDeleteModal(false);
        }
    };

    const onClickNewBranch = () => {
        setIsEdit(false);
        setBranch(null);
        toggle();
        //setModal(true)
    };

    const handleSuccess = (data) => {
        console.log("Import réussi :", data);
        // ici tu peux recharger la liste des facultés si besoin
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Nom",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Code",
                accessorKey: "code",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            {
                header: "Type de  formation",
                accessorKey: "training_type.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleBranchClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteBranch}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Filières" breadcrumbItem="Liste des filières" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="d-flex gap-2">
                                                    <Button color="success" onClick={() => setModalOpen(true)}>
                                                        Importer un fichier
                                                    </Button>


                                                    <Link to="#!" onClick={onClickNewBranch} className="btn btn-primary me-1">Ajouter une filière</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={branches || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Filière" : "Ajouter - Filière"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                        
                                        <div className="mb-3">
                                            <Label>Nom</Label>
                                            <Input
                                                name="name"
                                                type="text"
                                                placeholder="Nom"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.name || ""}
                                                invalid={
                                                    validation.touched.name && validation.errors.name ? true : false
                                                }
                                            />
                                            {validation.touched.name && validation.errors.name ? (
                                                <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Code</Label>
                                            <Input
                                                name="code"
                                                type="text"
                                                placeholder="Code"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.code || ""}
                                                invalid={
                                                    validation.touched.code && validation.errors.code ? true : false
                                                }
                                            />
                                            {validation.touched.code && validation.errors.code ? (
                                                <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Type de formation</Label>
                                            <Input
                                                name="training_type_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.training_type_id || ""
                                                }
                                                invalid={
                                                    validation.touched.training_type_id && validation.errors.training_type_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {trainingTypes.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.training_type_id && validation.errors.training_type_id ? (
                                                <FormFeedback type="invalid">{validation.errors.training_type_id}</FormFeedback>
                                            ) : null}
                                        </div>
                                       
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />

            <ImportBranchModal
                isOpen={modalOpen}
                toggle={() => setModalOpen(!modalOpen)}
                onSuccess={handleSuccess}
            />


        </React.Fragment>
    );
}


export default Branch;